(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-promo-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function rellenar(valor) {
    return valor < 10 ? '0' + valor : '' + valor;
  }

  /* ===========================================================
     MODOS DEL CONTADOR (7 sep 2026)

     "diario"    — termina cada dia a las 00:00 HORA DE ESPANA. Todas las
                   clientas ven el MISMO numero a la misma hora, entren desde
                   donde entren y con el navegador que sea. NO usa
                   localStorage: no hay nada que reiniciar ni que borrar, y
                   llega a cero de verdad todas las noches.
     "fecha"     — cuenta hasta `fecha_objetivo`. Al llegar sale el texto de
                   finalizado y ahi se queda.
     "visitante" — el de antes: 24 h desde la primera visita de CADA persona,
                   guardadas en su navegador. Ojo, quien vuelve pasado un dia
                   se encuentra el reloj lleno otra vez.

     ⚠️ POR QUE NO VALE `new Date().setHours(0,0,0,0)`: eso usa la hora del
     movil de quien mira. Una clienta en Canarias veria una hora menos y el
     contador dejaria de ser el mismo para todas. Hay que anclarlo a
     Europe/Madrid, que es el mercado de la tienda.
     =========================================================== */
  var ZONA_TIENDA = 'Europe/Madrid';

  function partesEnMadrid(instante) {
    var p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: ZONA_TIENDA,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    }).formatToParts(instante).forEach(function (x) { p[x.type] = x.value; });
    return p;
  }

  function desfaseZona(instante) {
    var p = partesEnMadrid(instante);
    // El % 24 es a proposito: con hour12:false algunos navegadores devuelven
    // "24" en vez de "00" a medianoche.
    var comoUTC = Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
    return comoUTC - instante.getTime();
  }

  function finDelDia(horaCorte) {
    var ahora = new Date();
    var p = partesEnMadrid(ahora);
    var arranqueDelDia = Date.UTC(+p.year, +p.month - 1, +p.day, 0, 0, 0);
    var objetivo = arranqueDelDia + horaCorte * 3600000;
    var ahoraEnMadrid = arranqueDelDia + ((+p.hour) % 24) * 3600000 + (+p.minute) * 60000 + (+p.second) * 1000;
    if (objetivo <= ahoraEnMadrid) {
      objetivo += 86400000;
    }
    // Dos pasadas: en las noches del cambio de hora (marzo y octubre) el
    // desfase del instante objetivo no es el de ahora, y sin recalcular el
    // contador iria una hora desviado justo esa noche.
    var aproximado = objetivo - desfaseZona(ahora);
    return objetivo - desfaseZona(new Date(aproximado));
  }

  function obtenerFin(contador) {
    var modo = contador.getAttribute('data-modo') || 'diario';

    if (modo === 'diario') {
      var corte = parseInt(contador.getAttribute('data-hora-corte'), 10);
      if (isNaN(corte) || corte < 0 || corte > 23) {
        corte = 0;
      }
      return finDelDia(corte);
    }

    if (modo === 'fecha') {
      var objetivo = Date.parse(contador.getAttribute('data-fecha') || '');
      return isNaN(objetivo) ? Date.now() : objetivo;
    }

    var horas = parseFloat(contador.getAttribute('data-horas')) || 24;
    var clave = 'barraPromoNazalea:' + contador.getAttribute('data-clave') + ':' + horas;
    var guardado = null;
    try {
      guardado = window.localStorage.getItem(clave);
    } catch (e) {}
    var fin = guardado ? parseInt(guardado, 10) : NaN;
    if (isNaN(fin) || fin <= Date.now()) {
      fin = Date.now() + horas * 3600000;
      try {
        window.localStorage.setItem(clave, fin);
      } catch (e) {}
    }
    return fin;
  }

  function iniciar(contador) {
    if (contador.getAttribute('data-iniciado') === 'true') {
      return;
    }
    contador.setAttribute('data-iniciado', 'true');

    var modo = contador.getAttribute('data-modo') || 'diario';
    var fin = obtenerFin(contador);
    var numHoras = contador.querySelector('[data-horas-num]');
    var numMin = contador.querySelector('[data-min-num]');
    var numSeg = contador.querySelector('[data-seg-num]');
    var textoFin = contador.getAttribute('data-finalizado') || '';
    var intervalo;

    function actualizar() {
      var restante = fin - Date.now();
      if (restante <= 0 && modo === 'diario') {
        // A las 00:00 no se acaba nada: arranca el dia siguiente y sigue.
        fin = obtenerFin(contador);
        restante = fin - Date.now();
      }
      if (restante <= 0) {
        if (intervalo) {
          clearInterval(intervalo);
        }
        contador.innerHTML = '<span class="barra-promo-nazalea__finalizado"></span>';
        contador.querySelector('.barra-promo-nazalea__finalizado').textContent = textoFin;
        return;
      }
      var totalSeg = Math.floor(restante / 1000);
      var horas = Math.floor(totalSeg / 3600);
      var minutos = Math.floor((totalSeg % 3600) / 60);
      var segundos = totalSeg % 60;
      if (numHoras) {
        numHoras.textContent = rellenar(horas);
      }
      if (numMin) {
        numMin.textContent = rellenar(minutos);
      }
      if (numSeg) {
        numSeg.textContent = rellenar(segundos);
      }
    }

    actualizar();
    intervalo = setInterval(actualizar, 1000);
  }

  function iniciarTodos(raiz) {
    var ambito = raiz || document;
    var contadores = ambito.querySelectorAll('.barra-promo-nazalea__contador');
    for (var i = 0; i < contadores.length; i++) {
      iniciar(contadores[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["destacados-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.dzListo === '1') return;
    raiz.dataset.dzListo = '1';

    var pistas = raiz.querySelectorAll('[data-dz-pista]');

    for (var i = 0; i < pistas.length; i++) {
      (function (pista) {
        var media = pista.parentElement;
        var caja = media.querySelector('[data-dz-puntos]');
        if (!caja) return;
        var puntos = caja.querySelectorAll('.destacados-nazalea__punto');
        if (puntos.length < 2) return;

        var pendiente = false;
        pista.addEventListener('scroll', function () {
          if (pendiente) return;
          pendiente = true;
          window.requestAnimationFrame(function () {
            pendiente = false;
            var indice = 0;
            if (pista.clientWidth > 0 && pista.scrollLeft > pista.clientWidth / 2) indice = 1;
            for (var k = 0; k < puntos.length; k++) {
              if (k === indice) puntos[k].classList.add('destacados-nazalea__punto--activo');
              else puntos[k].classList.remove('destacados-nazalea__punto--activo');
            }
          });
        }, { passive: true });
      })(pistas[i]);
    }
  }

  function barrer(ambito) {
    var todas = (ambito || document).querySelectorAll('[data-destacados-nazalea]');
    for (var i = 0; i < todas.length; i++) iniciar(todas[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { barrer(); });
  else barrer();
  document.addEventListener('shopify:section:load', function (e) { barrer(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.getAttribute('data-iniciado') === 'true') { return; }
    raiz.setAttribute('data-iniciado', 'true');

    var puntos = raiz.querySelectorAll('[data-punto]');
    for (var i = 0; i < puntos.length; i++) {
      puntos[i].addEventListener('click', function (e) {
        e.preventDefault();
        var media = e.currentTarget.closest('[data-media]');
        if (!media) { return; }
        var abierta = media.classList.contains('editorial-nazalea__media--abierta');
        var todas = raiz.querySelectorAll('[data-media]');
        for (var j = 0; j < todas.length; j++) {
          todas[j].classList.remove('editorial-nazalea__media--abierta');
        }
        if (!abierta) {
          media.classList.add('editorial-nazalea__media--abierta');
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (raiz.contains(e.target)) { return; }
      var todas = raiz.querySelectorAll('[data-media]');
      for (var k = 0; k < todas.length; k++) {
        todas[k].classList.remove('editorial-nazalea__media--abierta');
      }
    });
  }

  function iniciarTodos(ambito) {
    var raices = (ambito || document).querySelectorAll('[data-editorial-nazalea]');
    for (var i = 0; i < raices.length; i++) { iniciar(raices[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (e) { iniciarTodos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.getAttribute('data-iniciado') === 'true') { return; }
    raiz.setAttribute('data-iniciado', 'true');

    var cabeceras = raiz.querySelectorAll('[data-faq-cab]');
    for (var i = 0; i < cabeceras.length; i++) {
      cabeceras[i].addEventListener('click', function (e) {
        var item = e.currentTarget.closest('[data-faq-item]');
        if (!item) { return; }
        var abierto = item.classList.toggle('faq-nazalea__item--abierto');
        e.currentTarget.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    }
  }

  function iniciarTodos(ambito) {
    var raices = (ambito || document).querySelectorAll('[data-faq-nazalea]');
    for (var i = 0; i < raices.length; i++) { iniciar(raices[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (e) { iniciarTodos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function esMovil() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function buscarScroller(elemento) {
    var padre = elemento.parentElement;
    while (padre && padre !== document.documentElement) {
      var estilo = window.getComputedStyle(padre);
      var oy = estilo.overflowY;
      if ((oy === 'auto' || oy === 'scroll') && padre.scrollHeight > padre.clientHeight + 4) {
        return padre;
      }
      padre = padre.parentElement;
    }
    return window;
  }

  function iniciar(cabecera) {
    if (cabecera.getAttribute('data-iniciado') === 'true') { return; }
    cabecera.setAttribute('data-iniciado', 'true');

    var contenedor = cabecera.closest('.shopify-section') || cabecera.parentNode;
    var mega = contenedor.querySelector('[data-mega]');
    var zonaProductos = contenedor.querySelector('[data-productos]');
    var abrirMenu = contenedor.querySelector('[data-abrir-menu]');
    var cerrarMenu = contenedor.querySelector('[data-cerrar-menu]');
    var abrirBuscador = contenedor.querySelector('[data-abrir-buscador]');
    var buscador = contenedor.querySelector('[data-buscador]');
    var tabs = contenedor.querySelectorAll('[data-tab]');
    var paneles = contenedor.querySelectorAll('[data-panel]');
    var cats = contenedor.querySelectorAll('[data-cat]');
    var temporizador = null;

    function precargarFotos() {
      var imgs = contenedor.querySelectorAll('.header-nazalea__tarjeta-img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].setAttribute('loading', 'eager');
      }
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(precargarFotos, { timeout: 4000 });
    } else {
      setTimeout(precargarFotos, 2500);
    }

    if (cabecera.classList.contains('header-nazalea--fijo')) {
      var scroller = buscarScroller(contenedor);
      var objetivo = scroller === window ? window : scroller;

      var comprobarPegado = function () {
        var arriba = contenedor.getBoundingClientRect().top;
        cabecera.classList.toggle('header-nazalea--pegado', arriba <= 0.5);
      };

      objetivo.addEventListener('scroll', comprobarPegado, { passive: true });
      window.addEventListener('resize', comprobarPegado, { passive: true });
      comprobarPegado();
    }

    function activar(indice) {
      for (var i = 0; i < paneles.length; i++) {
        var esta = paneles[i].getAttribute('data-panel') === indice;
        paneles[i].classList.toggle('header-nazalea__panel--activo', esta);
      }
      for (var j = 0; j < tabs.length; j++) {
        var act = tabs[j].getAttribute('data-tab') === indice;
        tabs[j].classList.toggle('header-nazalea__tab--activo', act);
      }
    }

    function abrir() {
      if (!mega) { return; }
      clearTimeout(temporizador);
      precargarFotos();
      mega.classList.add('header-nazalea__mega--abierto');
      mega.setAttribute('aria-hidden', 'false');
      if (abrirMenu) { abrirMenu.setAttribute('aria-expanded', 'true'); }
      if (esMovil()) { document.body.style.overflow = 'hidden'; }
    }

    function cerrar() {
      if (!mega) { return; }
      mega.classList.remove('header-nazalea__mega--abierto');
      mega.setAttribute('aria-hidden', 'true');
      if (abrirMenu) { abrirMenu.setAttribute('aria-expanded', 'false'); }
      document.body.style.overflow = '';
    }

    function cerrarConRetraso() {
      clearTimeout(temporizador);
      temporizador = setTimeout(cerrar, 140);
    }

    if (zonaProductos) {
      zonaProductos.addEventListener('mouseenter', function () {
        if (!esMovil()) { abrir(); }
      });
      zonaProductos.addEventListener('focusin', function () {
        if (!esMovil()) { abrir(); }
      });
    }

    for (var c = 0; c < cats.length; c++) {
      cats[c].addEventListener('mouseenter', function (e) {
        if (esMovil()) { return; }
        abrir();
        activar(e.currentTarget.getAttribute('data-cat'));
      });
      cats[c].addEventListener('focus', function (e) {
        if (esMovil()) { return; }
        abrir();
        activar(e.currentTarget.getAttribute('data-cat'));
      });
    }

    cabecera.addEventListener('mouseleave', function () {
      if (!esMovil()) { cerrarConRetraso(); }
    });

    cabecera.addEventListener('mouseenter', function () {
      if (!esMovil()) { clearTimeout(temporizador); }
    });

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('mouseenter', function (e) {
        activar(e.currentTarget.getAttribute('data-tab'));
      });
      tabs[k].addEventListener('focus', function (e) {
        activar(e.currentTarget.getAttribute('data-tab'));
      });
    }

    function alternar() {
      if (mega && mega.classList.contains('header-nazalea__mega--abierto')) { cerrar(); } else { abrir(); }
    }

    if (abrirMenu) { abrirMenu.addEventListener('click', alternar); }
    if (cerrarMenu) { cerrarMenu.addEventListener('click', cerrar); }

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') { cerrar(); }
    });

    if (abrirBuscador && buscador) {
      abrirBuscador.addEventListener('click', function () {
        var abierto = buscador.classList.toggle('header-nazalea__buscador--abierto');
        buscador.setAttribute('aria-hidden', abierto ? 'false' : 'true');
        abrirBuscador.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        if (abierto) {
          var campo = buscador.querySelector('.header-nazalea__buscador-input');
          if (campo) { campo.focus(); }
        }
      });
    }
  }

  function iniciarTodos(raiz) {
    var ambito = raiz || document;
    var cabeceras = ambito.querySelectorAll('[data-header-nazalea]');
    for (var i = 0; i < cabeceras.length; i++) { iniciar(cabeceras[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) { iniciarTodos(evento.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["look-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.getAttribute('data-iniciado') === 'true') {
      return;
    }
    seccion.setAttribute('data-iniciado', 'true');

    var addUrl = seccion.getAttribute('data-add-url') || '/cart/add';
    var cartUrl = seccion.getAttribute('data-cart-url') || '/cart';
    if (addUrl.indexOf('.js') === -1) {
      addUrl = addUrl + '.js';
    }

    var botones = seccion.querySelectorAll('[data-anadir-look]');

    for (var i = 0; i < botones.length; i++) {
      botones[i].addEventListener('click', function (evento) {
        var boton = evento.currentTarget;
        var tarjeta = boton.closest('[data-look]');
        if (!tarjeta) {
          return;
        }

        var campos = tarjeta.querySelectorAll('[data-variante]');
        var articulos = [];
        for (var j = 0; j < campos.length; j++) {
          var valor = campos[j].value;
          if (valor) {
            articulos.push({ id: parseInt(valor, 10), quantity: 1 });
          }
        }

        if (articulos.length === 0) {
          return;
        }

        var etiqueta = boton.querySelector('[data-boton-texto]');
        var textoOriginal = etiqueta ? etiqueta.textContent : '';
        boton.disabled = true;
        if (etiqueta) {
          etiqueta.textContent = 'Anadiendo...';
        }

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: articulos })
        })
          .then(function (respuesta) {
            if (!respuesta.ok) {
              return respuesta.json().then(function (datos) {
                throw new Error(datos.description || datos.message || 'Error');
              });
            }
            return respuesta.json();
          })
          .then(function () {
            window.location.href = cartUrl;
          })
          .catch(function (error) {
            boton.disabled = false;
            if (etiqueta) {
              etiqueta.textContent = textoOriginal;
            }
            window.alert(error.message || 'No se pudo anadir el look al carrito.');
          });
      });
    }
  }

  function iniciarTodos(raiz) {
    var ambito = raiz || document;
    var secciones = ambito.querySelectorAll('[data-look-nazalea]');
    for (var i = 0; i < secciones.length; i++) {
      iniciar(secciones[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodos();
    });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nusa-barra-anuncio"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.anuncio-barra[data-fecha-fin]').forEach(function (barra) {
    var contador = barra.querySelector('.anuncio-barra__contador');
    if (!contador) return;

    var fechaFin = new Date(barra.dataset.fechaFin).getTime();
    if (isNaN(fechaFin)) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = Math.max(0, fechaFin - Date.now());
      contador.querySelector('[data-ab-tipo="horas"]').textContent = pad(Math.floor(diff / 3600000));
      contador.querySelector('[data-ab-tipo="minutos"]').textContent = pad(Math.floor((diff % 3600000) / 60000));
      contador.querySelector('[data-ab-tipo="segundos"]').textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nusa-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var header = document.getElementById('nusa-encabezado');
  var btnMenu = document.getElementById('nusa-btn-menu');
  var menuMovil = document.getElementById('nusa-menu-movil');
  var overlay = document.getElementById('nusa-overlay');
  var btnCerrar = document.getElementById('nusa-cerrar-menu');
  var btnBusqueda = document.getElementById('nusa-btn-busqueda');
  var btnCarrito = document.getElementById('nusa-btn-carrito');
  var numCarrito = document.getElementById('nusa-carrito-num');

  function abrirMenu() {
    menuMovil.classList.add('menu-movil--abierto');
    overlay.classList.add('menu-movil__overlay--visible');
    menuMovil.setAttribute('aria-hidden', 'false');
    btnMenu.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function cerrarMenu() {
    menuMovil.classList.remove('menu-movil--abierto');
    overlay.classList.remove('menu-movil__overlay--visible');
    menuMovil.setAttribute('aria-hidden', 'true');
    btnMenu.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (btnMenu) btnMenu.addEventListener('click', abrirMenu);
  if (btnCerrar) btnCerrar.addEventListener('click', cerrarMenu);
  if (overlay) overlay.addEventListener('click', cerrarMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarMenu();
  });

  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('encabezado--con-sombra', window.scrollY > 10);
    }, { passive: true });
  }

  if (btnBusqueda) {
    btnBusqueda.addEventListener('click', function () {
      var modal = document.querySelector('search-modal');
      if (modal && typeof modal.open === 'function') {
        modal.open();
      } else if (modal) {
        modal.dispatchEvent(new CustomEvent('open'));
      } else {
        window.location.href = '/search';
      }
    });
  }

  if (btnCarrito) {
    btnCarrito.addEventListener('click', function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = '/cart';
      }
    });
  }

  document.addEventListener('nusa:carrito-actualizado', function (e) {
    if (!numCarrito) return;
    var n = e.detail && e.detail.cantidad != null ? e.detail.cantidad : 0;
    numCarrito.textContent = n;
    numCarrito.classList.toggle('encabezado__carrito-num--oculto', n === 0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nusa-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sec) {
    if (sec.dataset.nrevReady === '1') return;
    sec.dataset.nrevReady = '1';
    var pista = sec.querySelector('[data-nrev-pista]');
    var cards = Array.prototype.slice.call(sec.querySelectorAll('[data-nrev-card]'));
    if (!pista || !cards.length) return;
    var prev = sec.querySelector('[data-nrev-prev]');
    var next = sec.querySelector('[data-nrev-next]');

    function marcarActiva() {
      var centro = pista.getBoundingClientRect().left + pista.clientWidth / 2;
      var mejor = null, dist = Infinity;
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - centro);
        if (d < dist) { dist = d; mejor = c; }
      });
      cards.forEach(function (c) { c.classList.toggle('nrev__card--activa', c === mejor); });
    }

    function irA(card) {
      if (!card) return;
      var izq = card.offsetLeft - (pista.clientWidth - card.clientWidth) / 2;
      pista.scrollTo({ left: izq, behavior: 'smooth' });
    }
    function activaIndex() { for (var i = 0; i < cards.length; i++) { if (cards[i].classList.contains('nrev__card--activa')) return i; } return 0; }

    if (prev) prev.addEventListener('click', function () { irA(cards[Math.max(0, activaIndex() - 1)]); });
    if (next) next.addEventListener('click', function () { irA(cards[Math.min(cards.length - 1, activaIndex() + 1)]); });

    var raf;
    pista.addEventListener('scroll', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(marcarActiva); }, { passive: true });
    window.addEventListener('resize', marcarActiva);

    // centra la tarjeta del medio al inicio
    var medio = cards[Math.floor(cards.length / 2)];
    marcarActiva();
    requestAnimationFrame(function () { var izq = medio.offsetLeft - (pista.clientWidth - medio.clientWidth) / 2; pista.scrollLeft = izq; marcarActiva(); });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-nrev]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parecidos-nazalea-backup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function cargar(sec) {
    if (sec.dataset.parecReady === '1') return;
    var url = sec.getAttribute('data-url');
    if (!url) return;
    sec.dataset.parecReady = '1';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nueva = doc.querySelector('[data-parec] .parec__inner');
      if (nueva) { sec.innerHTML = nueva.outerHTML; }
    }).catch(function () {});
  }
  function todos(scope) { (scope || document).querySelectorAll('[data-parec]').forEach(function (s) { if (!s.querySelector('.parec__inner')) { cargar(s); } }); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { todos(); }); } else { todos(); }
  document.addEventListener('shopify:section:load', function (e) { todos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parecidos-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Las flechas SOLO tienen sentido si sobra ancho. Si caben todas las
  // tarjetas, se esconde la fila entera en vez de dejar dos botones muertos.
  function estadoFlechas(sec) {
    var sc = sec.querySelector('[data-parec-scroller]');
    var nav = sec.querySelector('.parec__nav');
    if (!sc || !nav) return;
    var sobra = sc.scrollWidth > sc.clientWidth + 2;
    nav.hidden = !sobra;
    if (!sobra) return;
    var x = sc.scrollLeft;
    var fin = sc.scrollWidth - sc.clientWidth - 2;
    sec.querySelectorAll('[data-parec-ir]').forEach(function (b) {
      var atras = b.getAttribute('data-parec-ir') === '-1';
      b.disabled = atras ? x <= 2 : x >= fin;
    });
  }

  // ⚠️ EL SCROLL SUAVE SE IGNORA A VECES. Comprobado 22 ago 2026 en Chromium:
  // con `behavior: 'smooth'` el carrusel NO se movia ni un pixel (ni cambiando
  // scroll-snap a proximity, ni poniendo scroll-behavior en el CSS); con salto
  // seco si. Por eso se pide suave y, si a los 250ms no se ha movido nada, se
  // salta en seco. Asi la flecha funciona SIEMPRE, con animacion si se puede.
  function irA(sc, delta) {
    var tope = sc.scrollWidth - sc.clientWidth;
    var destino = Math.max(0, Math.min(sc.scrollLeft + delta, tope));
    var origen = sc.scrollLeft;
    try { sc.scrollTo({ left: destino, behavior: 'smooth' }); } catch (e) { sc.scrollLeft = destino; }
    setTimeout(function () {
      if (Math.abs(sc.scrollLeft - origen) < 2) { sc.scrollLeft = destino; }
      var s = sc.closest('[data-parec]');
      if (s) estadoFlechas(s);
    }, 250);
  }

  // Se pinta en el SERVIDOR: al cargar solo hay que fijar el estado inicial.
  function arranque() { document.querySelectorAll('[data-parec]').forEach(estadoFlechas); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', arranque); } else { arranque(); }
  document.addEventListener('shopify:section:load', arranque);
  window.addEventListener('resize', arranque);
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-parec-scroller')) {
      var s = e.target.closest('[data-parec]');
      if (s) estadoFlechas(s);
    }
  }, true);

  if (window.__parecUIListo) return;
  window.__parecUIListo = true;

  function cerrarTallas(menos) {
    document.querySelectorAll('[data-parec-tallas]').forEach(function (t) {
      if (t === menos) return;
      t.hidden = true;
      var b = t.parentElement.querySelector('[data-parec-abrir]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var flecha = e.target.closest('[data-parec-ir]');
    if (flecha) {
      var sec = flecha.closest('[data-parec]');
      var sc = sec && sec.querySelector('[data-parec-scroller]');
      var card = sc && sc.querySelector('.parec__card');
      if (sc && card) {
        var paso = card.getBoundingClientRect().width + parseFloat(getComputedStyle(sc).columnGap || 0);
        irA(sc, paso * parseInt(flecha.getAttribute('data-parec-ir'), 10));
      }
      return;
    }

    var abrir = e.target.closest('[data-parec-abrir]');
    if (abrir) {
      e.preventDefault();
      var caja = abrir.parentElement.querySelector('[data-parec-tallas]');
      if (!caja) return;
      var abierto = !caja.hidden;
      cerrarTallas(caja);
      caja.hidden = abierto;
      abrir.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      return;
    }

    var talla = e.target.closest('[data-parec-id]');
    if (talla) {
      e.preventDefault();
      var form = talla.closest('[data-parec-add]');
      if (!form) return;
      form.querySelector('input[name="id"]').value = talla.getAttribute('data-parec-id');
      cerrarTallas(null);
      if (form.requestSubmit) { form.requestSubmit(); }
      else { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
      return;
    }

    if (!e.target.closest('[data-parec-tallas]')) cerrarTallas(null);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarTallas(null); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var DIAS = ['domingo','lunes','martes','miercoles','jueves','viernes','sabado'];
  function sumarHabiles(desde, dias) { var d = new Date(desde.getTime()); var q = dias; while (q > 0) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) { q--; } } return d; }
  function formatear(d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES[d.getMonth()]; }

  function iniciar(raiz) {
    if (raiz.getAttribute('data-iniciado') === 'true') { return; }
    raiz.setAttribute('data-iniciado', 'true');

    var entrega = raiz.querySelector('[data-entrega]');
    if (entrega) {
      var et = entrega.querySelector('[data-entrega-texto]');
      var min = parseInt(entrega.getAttribute('data-min'), 10) || 7;
      var max = parseInt(entrega.getAttribute('data-max'), 10) || 14;
      var hoy = new Date();
      if (et) { et.innerHTML = (et.textContent || '').trim() + ' <strong>' + formatear(sumarHabiles(hoy, min)) + '</strong> y <strong>' + formatear(sumarHabiles(hoy, max)) + '</strong>.'; }
    }

    var acordeones = raiz.querySelectorAll('[data-acordeon]');
    for (var k = 0; k < acordeones.length; k++) {
      var cab = acordeones[k].querySelector('[data-acordeon-cab]');
      if (cab) { cab.addEventListener('click', function (e) { e.currentTarget.closest('[data-acordeon]').classList.toggle('producto-nazalea__acordeon--abierto'); }); }
    }
    var abrirGuia = raiz.querySelector('[data-abrir-guia]');
    var guia = raiz.querySelector('[data-guia]');
    if (abrirGuia && guia) { abrirGuia.addEventListener('click', function () { guia.classList.add('producto-nazalea__acordeon--abierto'); guia.scrollIntoView({ behavior: 'smooth', block: 'center' }); }); }

    var botones = raiz.querySelectorAll('[data-valor]');
    var campoId = raiz.querySelector('[data-variant-id]');
    var precio = raiz.querySelector('[data-precio]');
    var antes = raiz.querySelector('[data-antes]');
    var boton = raiz.querySelector('[data-boton]');
    var botonTexto = raiz.querySelector('[data-boton-texto]');
    var botonPrecio = raiz.querySelector('[data-boton-precio]');
    var fotos = raiz.querySelectorAll('[data-media-id]');
    var datos = null;
    var txtOk = botonTexto ? botonTexto.textContent.trim() : '';
    var txtKo = raiz.getAttribute('data-agotado') || 'Agotado';

    /*
      EL EURO VA DETRAS, COMO EN EL RESTO DE LA TIENDA (23 sep 2026).

      LO QUE PASABA: al cargar la ficha el precio decia "44,95 EUR" (lo pinta
      Shopify con el filtro money, que si respeta el formato de la tienda),
      pero EN CUANTO LA CLIENTA PULSABA UN COLOR esta funcion lo repintaba
      como "EUR44,95", con el simbolo delante. Medido ese dia en DELFINA y en
      TERESINA: le pasaba a TODA prenda con selector de color.

      POR QUE: la version vieja hacia
          Shopify.formatMoney(cents, '{ { shop.money_format } }')
      y si eso fallaba se pegaba el simbolo delante a mano.
      DOS FALLOS A LA VEZ:
        1. Dentro de un bloque {% javascript %} Shopify NO interpreta Liquid.
           Ese { { shop.money_format } } llegaba al navegador TAL CUAL, como
           texto, o sea un formato invalido.
        2. `Shopify.formatMoney` no esta cargado en estas paginas, asi que
           siempre caia al respaldo... que era justo el del simbolo delante.

      COMO SE ARREGLA: el formato de verdad se pasa por un atributo del div
      raiz (`data-money-format`), que SI es Liquid normal y si se interpreta.
      Aqui se lee de ahi y se sustituye el hueco del importe.

      ⚠️ VENTAJA SOBRE `assets/pn-ficha2.js`: alli el formato esta escrito a
      mano y hay que volver a tocarlo si algun dia se cambia el formato de
      moneda en Configuracion. Aqui no: se coge de la tienda solo.

      ⚠️ LAS LLAVES SE MONTAN SUMANDO ('{' + '{') a proposito: escribirlas
      juntas dentro de este bloque es buscarse un problema con el lexer.
    */
    var FORMATO = raiz.getAttribute('data-money-format') || '';
    var ABRE = '{' + '{';
    var CIERRA = '}' + '}';

    function dinero(cents) {
      var n = (cents / 100).toFixed(2).replace('.', ',');
      if (FORMATO && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, FORMATO);
      }
      var ini = FORMATO.indexOf(ABRE);
      var fin = FORMATO.indexOf(CIERRA);
      if (ini !== -1 && fin > ini) {
        return FORMATO.slice(0, ini) + n + FORMATO.slice(fin + CIERRA.length);
      }
      return n + ' €';
    }

    function filtrarPorColor(valor) {
      if (!fotos.length) { return; }
      var vv = (valor || '').toLowerCase().trim();
      var hay = false;
      for (var i = 0; i < fotos.length; i++) { if (fotos[i].getAttribute('data-color') === vv) { hay = true; break; } }
      for (var j = 0; j < fotos.length; j++) {
        if (!hay) { fotos[j].style.display = ''; }
        else { fotos[j].style.display = (fotos[j].getAttribute('data-color') === vv) ? '' : 'none'; }
      }
      document.dispatchEvent(new CustomEvent('nazalea:fotos-filtradas', { bubbles: true }));
    }

    function irAFoto(mediaId) {
      if (!mediaId) { return; }
      var foto = raiz.querySelector('[data-media-id="' + mediaId + '"]');
      if (!foto || foto.style.display === 'none') { return; }
      foto.scrollIntoView({ behavior: 'smooth', block: 'center' });
      foto.classList.add('producto-nazalea__foto--resaltada');
      setTimeout(function () { foto.classList.remove('producto-nazalea__foto--resaltada'); }, 1400);
    }

    function cargarDatos() { if (datos) { return Promise.resolve(datos); } return fetch(window.location.pathname + '.js').then(function (r) { return r.json(); }).then(function (j) { datos = j; return j; }); }

    function seleccionadas() {
      var out = [];
      var grupos = raiz.querySelectorAll('[data-grupo]');
      for (var g = 0; g < grupos.length; g++) {
        var a = grupos[g].querySelector('.producto-nazalea__valor--activo, .producto-nazalea__muestra--activo');
        out.push(a ? a.getAttribute('data-valor') : null);
      }
      return out;
    }
    function colorElegido() {
      var grupo = raiz.querySelector('[data-es-color="true"]');
      if (!grupo) { return null; }
      var a = grupo.querySelector('.producto-nazalea__valor--activo, .producto-nazalea__muestra--activo');
      return a ? a.getAttribute('data-valor') : null;
    }

    function actualizar() {
      cargarDatos().then(function (p) {
        var elegidas = seleccionadas();
        var enc = null;
        for (var i = 0; i < p.variants.length; i++) {
          var vr = p.variants[i], ok = true;
          for (var o = 0; o < elegidas.length; o++) { if (elegidas[o] !== null && vr.options[o] !== elegidas[o]) { ok = false; break; } }
          if (ok) { enc = vr; break; }
        }
        if (!enc) { return; }
        if (campoId) { campoId.value = enc.id; }
        if (precio) { precio.textContent = dinero(enc.price); }
        if (antes) { if (enc.compare_at_price && enc.compare_at_price > enc.price) { antes.textContent = dinero(enc.compare_at_price); antes.style.display = ''; } else { antes.style.display = 'none'; } }
        if (boton && botonTexto) { boton.disabled = !enc.available; botonTexto.textContent = enc.available ? txtOk : txtKo; }
        if (botonPrecio) { botonPrecio.innerHTML = enc.available ? '&middot; ' + dinero(enc.price) : ''; }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', enc.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      });
    }

    for (var n = 0; n < botones.length; n++) {
      botones[n].addEventListener('click', function (e) {
        var b = e.currentTarget;
        if (b.classList.contains('producto-nazalea__valor--agotado') || b.classList.contains('producto-nazalea__muestra--agotado')) { return; }
        var grupo = b.closest('[data-grupo]');
        var hermanos = grupo.querySelectorAll('[data-valor]');
        for (var h = 0; h < hermanos.length; h++) {
          var es = hermanos[h] === b;
          hermanos[h].classList.toggle('producto-nazalea__valor--activo', es && hermanos[h].classList.contains('producto-nazalea__valor'));
          hermanos[h].classList.toggle('producto-nazalea__muestra--activo', es && hermanos[h].classList.contains('producto-nazalea__muestra'));
        }
        var idx = grupo.getAttribute('data-grupo');
        var etiqueta = raiz.querySelector('[data-elegido-' + idx + ']');
        if (etiqueta) { etiqueta.innerHTML = ' &middot; ' + b.getAttribute('data-valor'); }
        if (grupo.getAttribute('data-es-color') === 'true') { filtrarPorColor(b.getAttribute('data-valor')); }
        irAFoto(b.getAttribute('data-media'));
        actualizar();
      });
    }

    filtrarPorColor(colorElegido());
  }

  function iniciarTodos(ambito) { var r = (ambito || document).querySelectorAll('[data-producto-nazalea]'); for (var i = 0; i < r.length; i++) { iniciar(r[i]); } }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); }); } else { iniciarTodos(); }
  document.addEventListener('shopify:section:load', function (e) { iniciarTodos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.getAttribute('data-ini') === '1') { return; }
    raiz.setAttribute('data-ini', '1');

    var pista = raiz.querySelector('[data-rs-pista]');
    var ant = raiz.querySelector('[data-rs-ant]');
    var sig = raiz.querySelector('[data-rs-sig]');
    if (!pista || !ant || !sig) { return; }

    function paso() {
      var t = pista.querySelector('.rs-nazalea__tarjeta');
      if (!t) { return pista.clientWidth; }
      return t.offsetWidth + 14;
    }

    ant.addEventListener('click', function () {
      pista.scrollBy({ left: -paso(), behavior: 'smooth' });
    });

    sig.addEventListener('click', function () {
      pista.scrollBy({ left: paso(), behavior: 'smooth' });
    });

    function revisar() {
      var sobra = pista.scrollWidth > pista.clientWidth + 4;
      ant.hidden = !sobra;
      sig.hidden = !sobra;
    }

    revisar();
    window.addEventListener('resize', revisar);
  }

  function todos(ambito) {
    var r = (ambito || document).querySelectorAll('[data-resenas]');
    for (var i = 0; i < r.length; i++) { iniciar(r[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { todos(); });
  } else { todos(); }

  document.addEventListener('shopify:section:load', function (e) { todos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.trendingListo === '1') return;
    var pista = raiz.querySelector('[data-trending-nazalea-pista]');
    var caja = raiz.querySelector('[data-trending-nazalea-puntos]');
    if (!pista || !caja) return;
    raiz.dataset.trendingListo = '1';

    var tarjetas = pista.querySelectorAll('.trending-nazalea__tarjeta');
    if (tarjetas.length < 2) return;

    var puntos = [];
    for (var i = 0; i < tarjetas.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'trending-nazalea__punto';
      b.setAttribute('aria-label', 'Ir a la tarjeta ' + (i + 1));
      (function (indice) {
        b.addEventListener('click', function () {
          pista.scrollTo({ left: tarjetas[indice].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
        });
      })(i);
      caja.appendChild(b);
      puntos.push(b);
    }

    function marcar() {
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var mejor = 0;
      var dif = Infinity;
      for (var j = 0; j < tarjetas.length; j++) {
        var c = tarjetas[j].offsetLeft - pista.offsetLeft + tarjetas[j].offsetWidth / 2;
        var d = Math.abs(c - centro);
        if (d < dif) { dif = d; mejor = j; }
      }
      for (var k = 0; k < puntos.length; k++) {
        if (k === mejor) puntos[k].classList.add('trending-nazalea__punto--activo');
        else puntos[k].classList.remove('trending-nazalea__punto--activo');
      }
    }

    var pendiente = false;
    pista.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () { pendiente = false; marcar(); });
    }, { passive: true });

    marcar();
  }

  function barrer() {
    var todas = document.querySelectorAll('[data-trending-nazalea]');
    for (var i = 0; i < todas.length; i++) iniciar(todas[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', barrer);
  else barrer();
  document.addEventListener('shopify:section:load', barrer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-nazalea"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.getAttribute('data-iniciado') === 'true') { return; }
    seccion.setAttribute('data-iniciado', 'true');

    var botones = seccion.querySelectorAll('[data-play]');
    for (var i = 0; i < botones.length; i++) {
      botones[i].addEventListener('click', function (evento) {
        var tarjeta = evento.currentTarget.closest('[data-tarjeta]');
        if (!tarjeta) { return; }
        var video = tarjeta.querySelector('[data-video]');
        if (!video) { return; }

        var todos = seccion.querySelectorAll('[data-video]');
        for (var j = 0; j < todos.length; j++) {
          if (todos[j] !== video) {
            todos[j].pause();
            var otra = todos[j].closest('[data-tarjeta]');
            if (otra) { otra.classList.remove('videos-nazalea__tarjeta--reproduciendo'); }
          }
        }

        video.setAttribute('controls', 'controls');
        tarjeta.classList.add('videos-nazalea__tarjeta--reproduciendo');
        video.play();
      });
    }

    var videos = seccion.querySelectorAll('[data-video]');
    for (var k = 0; k < videos.length; k++) {
      videos[k].addEventListener('pause', function (evento) {
        var tarjeta = evento.currentTarget.closest('[data-tarjeta]');
        if (tarjeta && evento.currentTarget.currentTime === 0) {
          tarjeta.classList.remove('videos-nazalea__tarjeta--reproduciendo');
        }
      });
    }
  }

  function iniciarTodos(raiz) {
    var ambito = raiz || document;
    var secciones = ambito.querySelectorAll('[data-videos-nazalea]');
    for (var i = 0; i < secciones.length; i++) { iniciar(secciones[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (evento) { iniciarTodos(evento.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
